/** Autosave / trust status for grading studio and related surfaces. */
export type TrustAutosaveStatus = 'idle' | 'saving' | 'saved' | 'error' | 'offline';

export const TRUST_AUTOSAVE_DEBOUNCE_MS = 800;
export const TRUST_AUTOSAVE_SAVED_FADE_MS = 2200;
